<script setup lang="ts">
import NavBar from '@/components/layout/NavBar.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import HeroSection from '@/components/home/HeroSection.vue'
import ForOrganizersSection from '@/components/home/ForOrganizersSection.vue'
import ForParticipantsSection from '@/components/home/ForParticipantsSection.vue'
</script>

<template>
  <div class="flex flex-col min-h-screen">
    <NavBar />
    <main class="flex-1">
      <HeroSection />
      <ForOrganizersSection />
      <ForParticipantsSection />
    </main>
    <AppFooter />
  </div>
</template>
